const localeMain = require("./locale-main.json");
const localeLanding = require("./locale-landing.json");
const localeFav = require("./locale-fav.json");
const localeFooter = require("./locale-footer.json");
const localePrivacy = require("./locale-privacy.json");
const localeReserve = require("./locale-reserve.json");
const localeTerms = require("./locale-terms.json");
const localeHosts = require("./locale-hosts.json");
const localeMyAccount = require("./locale-myaccount.json");
const localeAdmin = require("./locale-admin.json");
export class Locale {
    public static locale = Locale.formatJson();

    static formatJson(){
        let result = {};
        result = {
            "ES": {
                ...localeMain.ES,
                ...localeLanding.ES,
                ...localeFav.ES,
                ...localeFooter.ES,
                ...localePrivacy.ES,
                ...localeReserve.ES,
                ...localeTerms.ES,
                ...localeHosts.ES,
                ...localeMyAccount.ES,
                ...localeAdmin.ES
            },
            "EN": {
                ...localeMain.EN,
                ...localeLanding.EN,
                ...localeFav.EN,
                ...localeFooter.EN,
                ...localePrivacy.EN,
                ...localeReserve.EN,
                ...localeTerms.EN,
                ...localeHosts.EN,
                ...localeMyAccount.EN,
                ...localeAdmin.EN
            },
            "FR": {
                ...localeMain.FR,
                ...localeLanding.FR,
                ...localeFav.FR,
                ...localeFooter.FR,
                ...localePrivacy.FR,
                ...localeReserve.FR,
                ...localeTerms.FR,
                ...localeHosts.FR,
                ...localeMyAccount.FR,
                ...localeAdmin.FR
            },
            "DE": {
                ...localeMain.DE,
                ...localeLanding.DE,
                ...localeFav.DE,
                ...localeFooter.DE,
                ...localePrivacy.DE,
                ...localeReserve.DE,
                ...localeTerms.DE,
                ...localeHosts.DE,
                ...localeMyAccount.DE,
                ...localeAdmin.DE
            }
        }

        return result;       
    }
}